/**
 * Shared field-level validation helpers used across all forms (frontend).
 * Mirrors the backend rules so email-in-phone and other type mismatches are
 * caught before anything is submitted.
 */

/** Accepts standard email addresses: local@domain.tld */
export function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

/**
 * Accepts phone numbers: 7-15 digits (plus spaces, +, -, parentheses).
 * Explicitly rejects emails and alphabetic characters so a stray email typed
 * into a "phone" field is never accepted.
 */
export function isValidPhone(value: string): boolean {
  const v = value.trim();
  if (!v) return false;
  if (/[a-zA-Z@]/.test(v.replace(/\s/g, ''))) return false;
  const digits = v.replace(/\D/g, '');
  return digits.length >= 7 && digits.length <= 15;
}

/** Returns true if the string contains an @ (i.e. looks like an email). */
export function looksLikeEmail(value: string): boolean {
  return value.includes('@');
}

/** Ensure a string only contains characters allowed in a phone number. */
export function isPhoneCharacterSafe(value: string): boolean {
  return /^[0-9+\-\s()]+$/.test(value.trim());
}